import createAction from './create-action';
import ApiService from '../../services/api-service';
import { Dispatch } from 'redux';
import DataService from '../../services/data-service';
import { CancelToken } from 'axios';

/**
 * ACTION TYPES
 */
export const STORY_GET = 'story:get';
export const STORY_SUBTITLES_GET = 'story:getSubtitles';
export const STORY_TOGGLE_FAVORITE = 'story:toggleAsFavorite';

/**
 * THUNKS
 */

export const resetStory = () => (dispatch: Dispatch) => dispatch(createAction(`${STORY_GET}:reset`));

export const getStory = (university: string, storyId: string | number, cancelToken?: CancelToken) => (dispatch: Dispatch) => {
  return dispatch(
    createAction(STORY_GET, ApiService.getStory(university, storyId, undefined, cancelToken), {
      __PARSABLE__: true,
    })
  );
};

export const resetSubtitles = () => (dispatch: Dispatch) => dispatch(createAction(`${STORY_SUBTITLES_GET}:reset`));

export const getSubtitles = (storyId: string | number) => (dispatch: Dispatch) => {
  return dispatch(createAction(STORY_SUBTITLES_GET, ApiService.getSubtitles(storyId)));
};

export const getStoryWithSubtitles = (university: string, storyId: string | number) => async (dispatch: Dispatch) => {
  dispatch(createAction(`${STORY_GET}:loading`));
  dispatch(createAction(`${STORY_SUBTITLES_GET}:loading`));

  try {
    const { data: storyData } = await ApiService.getStory(university, storyId);
    const isSuccess = DataService.isSuccess(storyData);
    const storyPayload = isSuccess ? DataService.parseData(storyData) : DataService.parseErrors(storyData);

    if (!isSuccess || !storyPayload) {
      dispatch(createAction(`${STORY_GET}:error`, storyPayload));
      dispatch(createAction(`${STORY_SUBTITLES_GET}:error`, { message: '' }));
      return false;
    }

    const subtitlesData = await ApiService.getSubtitles(storyPayload.id);

    dispatch(createAction(`${STORY_GET}:success`, storyPayload));
    dispatch(createAction(`${STORY_SUBTITLES_GET}:success`, subtitlesData));
    return true;
  } catch (e) {
    console.error('error: getStoryWithSubtitles', e);
    dispatch(
      createAction(`${STORY_GET}:error`, {
        message: "Problem with getting story or it's subtitles",
      })
    );
    dispatch(createAction(`${STORY_SUBTITLES_GET}:error`, { message: '' }));
  }

  return false;
};

export const toggleStoryAsFavorite = (id: string | number, favorite: boolean) => (dispatch: Dispatch) => {
  return dispatch(
    createAction(STORY_TOGGLE_FAVORITE, ApiService.toggleStroyAsFavorite(id, favorite), {
      __PARSABLE__: true,
    })
  );
};
